(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1242],{

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 68359:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/universul-lego",
      function () {
        return __webpack_require__(80623);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/structuredData.js
var structuredData = __webpack_require__(89229);
;// CONCATENATED MODULE: ./components/BreadcrumbSchema.js




var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, baseUrl = _publicRuntimeConfig.settings.baseUrl;
var BreadcrumbSchema = function(param) {
    var breadcrumbData = param.breadcrumbData, currentPath = param.currentPath;
    // Do not include home page
    // Do not include pages without parent
    if (breadcrumbData && breadcrumbData.length > 1) {
        var itemListElement = breadcrumbData.map(function(breadcrumb, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                name: breadcrumb.name,
                item: breadcrumb.level != 99 ? "".concat(baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || "") : "".concat(baseUrl).concat(currentPath)
            };
        });
        var schema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: itemListElement
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: (0,structuredData/* default */.Z)(schema)
            }
        }));
    }
    return null;
};
/* harmony default export */ var components_BreadcrumbSchema = (BreadcrumbSchema);

;// CONCATENATED MODULE: ./components/Breadcrumbs.js








var Breadcrumbs_ref = (0,config["default"])(), settings = Breadcrumbs_ref.publicRuntimeConfig.settings;
var isBricoStore = settings.websiteName === "bricostore";
var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, _isPDP = param.isPDP, isPDP = _isPDP === void 0 ? false : _isPDP, className = param.className;
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BreadcrumbSchema, {
                breadcrumbData: breadcrumbs,
                currentPath: router.asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Breadcrumbs is-hidden-in-mobile-app pb-3 lg:py-3 truncate text-sm ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    className: "p-0 m-0 list-none inline",
                    children: breadcrumbs.map(function(breadcrumb, index) {
                        return breadcrumb.level != 99 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: classnames_default()("inline", {
                                "text-red-brand": isBricoStore || !isPDP,
                                "text-[#1D4ED8]": !isBricoStore && isPDP
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "".concat(settings.baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        title: breadcrumb.name,
                                        className: classnames_default()({
                                        }),
                                        children: breadcrumb.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mx-1",
                                    children: "/"
                                })
                            ]
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "inline",
                            children: breadcrumb.name
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index));
                    })
                })
            })
        ]
    }));
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        level: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        url_key: function(props, propName) {
            if (props["level"] !== 99 && (typeof props[propName] !== "string" || props[propName].length === 0)) {
                return new Error("Please provide url_key when item level is not 99.");
            }
        },
        url_suffix: (prop_types_default()).string
    })).isRequired
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 97995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var FullWidthSection = function(param) {
    var children = param.children, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "transparent" : _backgroundColor, _padding = param.padding, padding = _padding === void 0 ? "py-6" : _padding, _classProvided = param.classProvided, classProvided = _classProvided === void 0 ? "" : _classProvided, bgImmage = param.bgImmage;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative w-screen ".concat(backgroundColor, " ") + classProvided,
        style: {
            left: "50%",
            right: "50%",
            marginLeft: "-50vw",
            marginRight: "-50vw",
            backgroundImage: bgImmage !== undefined ? "url(".concat(bgImmage, ")") : "",
            backgroundRepeat: bgImmage !== undefined ? "no-repeat" : "",
            backgroundPosition: bgImmage !== undefined ? "right 3% bottom 7%" : "",
            backgroundSize: bgImmage !== undefined ? "160px 160px" : ""
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container ".concat(padding),
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullWidthSection);


/***/ }),

/***/ 97119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);



var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), settings = ref.publicRuntimeConfig.settings;
var ResponsiveHeroBanner = function(param) {
    var banner = param.banner;
    var ref12, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var desktopImage = (ref12 = banner.images) === null || ref12 === void 0 ? void 0 : (ref1 = ref12[0]) === null || ref1 === void 0 ? void 0 : ref1.file;
    var tabletImage = (ref2 = banner.images_tablet) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.file;
    var mobileImage = (ref4 = banner.images_mobile) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.file;
    var link = ((ref6 = banner.images) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.link) || ((ref8 = banner.images_mobile) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.link) || ((ref10 = banner.images_tablet) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.link);
    var hasImage = desktopImage || tabletImage || mobileImage;
    if (!hasImage) {
        return null;
    }
    if (link) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
            href: link,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                title: "",
                children: [
                    mobileImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(settings.cdn).concat(mobileImage),
                        className: "w-full sm:hidden",
                        alt: ""
                    }),
                    tabletImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(settings.cdn).concat(tabletImage),
                        className: "w-full hidden sm:block lg:hidden rounded-tr-lg rounded-bl-lg",
                        alt: ""
                    }),
                    desktopImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(settings.cdn).concat(desktopImage),
                        className: "w-full hidden lg:block rounded-tr-lg rounded-bl-lg",
                        alt: ""
                    })
                ]
            })
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            mobileImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat(settings.cdn).concat(mobileImage),
                className: "w-full sm:hidden",
                alt: ""
            }),
            tabletImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat(settings.cdn).concat(tabletImage),
                className: "w-full hidden sm:block lg:hidden rounded-tr-lg rounded-bl-lg",
                alt: ""
            }),
            desktopImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat(settings.cdn).concat(desktopImage),
                className: "w-full hidden lg:block rounded-tr-lg rounded-bl-lg",
                alt: ""
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveHeroBanner);


/***/ }),

/***/ 89229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35035);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__);

// JSON-LD blocks are injected with dangerouslySetInnerHTML, so a "<" coming
// from product data (a "</script>" inside a product name or description) would
// close the script element early and make the whole block unparsable for
// crawlers, besides letting the markup run in the browser. These characters
// are only ever part of JSON string values, where the escaped form is
// equivalent, so escaping them keeps the JSON valid and the page safe.
var HTML_UNSAFE_ESCAPES = {
    "<": "\\u003c",
    ">": "\\u003e",
    "&": "\\u0026"
};
var serializeSchema = function(schema) {
    return fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default()(schema).replace(/[<>&]/g, function(character) {
        return HTML_UNSAFE_ESCAPES[character];
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (serializeSchema);


/***/ }),

/***/ 6100:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var transformV2Banners = function(banners) {
    var basePath = "/media";
    var getImageObject = function(filePath, link) {
        return {
            link: link || "/",
            file: basePath + filePath
        };
    };
    var result = {
        id: banners.id || "",
        name: banners.name || "",
        position: banners.position || "",
        images: [],
        images_mobile: [],
        images_tablet: []
    };
    banners.images.forEach(function(item) {
        if (item.file) {
            result.images.push(getImageObject(item.file, item.url));
        }
        if (item.file_mobile) {
            result.images_mobile.push(getImageObject(item.file_mobile, item.url));
        }
        if (item.file_tablet) {
            result.images_tablet.push(getImageObject(item.file_tablet, item.url));
        }
    });
    return result;
};
/* harmony default export */ __webpack_exports__["Z"] = (transformV2Banners);


/***/ }),

/***/ 80623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ universul_lego; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./components/ResponsiveHeroBanner.js
var ResponsiveHeroBanner = __webpack_require__(97119);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/LegoByAge.js




var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var ages = [
    {
        img: "1-2-ani",
        value: "6-9-luni_9-12-luni_1-2-ani_2-3-ani"
    },
    {
        img: "3-4-ani",
        value: "2-3-ani_3-4-ani_4-5-ani"
    },
    {
        img: "5-7-ani",
        value: "4-5-ani_5-6-ani_6-7-ani"
    },
    {
        img: "8-10-ani",
        value: "7-8-ani_8-9-ani_9-10-ani"
    },
    {
        img: "10-12-ani",
        value: "10-11-ani_11-12-ani"
    },
    {
        img: "12-plus-ani",
        value: "peste-12-ani"
    }, 
];
var LegoByAge = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-8 sm:max-w-[60%] md:max-w-[35%] -ml-[8px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "".concat(settings.websiteStatics, "/images/universul-lego/age_title.png"),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-3",
                children: ages.map(function(param, index) {
                    var img = param.img, value = param.value;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/lego-jucarii/cpl/filtru/varsta-8282/".concat(value, "/"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                title: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(settings.websiteStatics, "/images/universul-lego/varsta/").concat(img, ".png"),
                                    alt: ""
                                })
                            })
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var components_LegoByAge = (LegoByAge);

// EXTERNAL MODULE: ./components/FullWidthSection.js
var FullWidthSection = __webpack_require__(97995);
;// CONCATENATED MODULE: ./components/LegoByPassion.js





var LegoByPassion_ref = (0,config["default"])(), LegoByPassion_settings = LegoByPassion_ref.publicRuntimeConfig.settings;
var passions = [
    {
        img: "masini-si-vehicule",
        value: "masini_trenuri_vehicule"
    },
    {
        img: "casute",
        value: "casute"
    },
    {
        img: "cinema-si-supereroi",
        value: "cinema_super-eroi"
    },
    {
        img: "spatiu",
        value: "spatiu"
    },
    {
        img: "decor",
        value: "decor_arhitectura"
    },
    {
        img: "animale",
        value: "animale"
    },
    {
        img: "printese",
        value: "printese"
    },
    {
        img: "politie-si-pompieri",
        value: "politie_pompieri"
    },
    {
        img: "jocuri-video",
        value: "jocuri-video"
    },
    {
        img: "caramizi-variate",
        value: "caramizi-variate"
    }, 
];
var LegoByPassion = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-8 sm:max-w-[60%] md:max-w-[35%] -ml-[8px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "".concat(LegoByPassion_settings.websiteStatics, "/images/universul-lego/passion_title.png"),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSection/* default */.Z, {
                padding: "p-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "grid grid-rows-2 grid-flow-col overflow-x-scroll gap-4 px-4 md:grid-flow-row md:grid-rows-none md:grid-cols-4 lg:grid-cols-5",
                    children: passions.map(function(param, index) {
                        var img = param.img, value = param.value;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            className: "w-40 sm:w-48 md:w-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/lego-jucarii/cpl/filtru/interese-9351/".concat(value, "/"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    title: "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(LegoByPassion_settings.websiteStatics, "/images/universul-lego/pasiune/").concat(img, ".png"),
                                        alt: ""
                                    })
                                })
                            })
                        }, index);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_LegoByPassion = (LegoByPassion);

;// CONCATENATED MODULE: ./components/LegoByTheme.js





var LegoByTheme_ref = (0,config["default"])(), LegoByTheme_settings = LegoByTheme_ref.publicRuntimeConfig.settings;
var themes = [
    {
        img: "sonic",
        value: "colectie-8837/sonic"
    },
    {
        img: "speed-champions",
        value: "colectie-8837/speed-champions"
    },
    {
        img: "super-mario",
        value: "colectie-8837/super-mario"
    },
    {
        img: "star-wars",
        value: "colectie-8837/star-wars"
    },
    {
        img: "technic",
        value: "colectie-8837/technic"
    },
    {
        img: "architecture",
        value: "colectie-8837/architecture"
    },
    {
        img: "art",
        value: "colectie-8837/art"
    },
    {
        img: "botanicals",
        value: "colectie-8837/botanicals"
    },
    {
        img: "city",
        value: "colectie-8837/city"
    },
    {
        img: "classic",
        value: "colectie-8837/classic"
    },
    {
        img: "creator-3-in-1",
        value: "colectie-8837/creator/varsta-8282/10-11-ani_9-10-ani_8-9-ani_7-8-ani_6-7-ani_11-12-ani"
    },
    {
        img: "disney",
        value: "colectie-8837/disney"
    },
    {
        img: "dreamzzz",
        value: "colectie-8837/dreamzzz"
    },
    {
        img: "duplo",
        value: "colectie-8837/duplo"
    },
    {
        img: "friends",
        value: "colectie-8837/friends"
    },
    {
        img: "icons",
        value: "colectie-8837/icons"
    },
    {
        img: "ideas",
        value: "colectie-8837/creator-expert_ideas"
    },
    {
        img: "marvel",
        value: "colectie-8837/marvel"
    },
    {
        img: "minecraft",
        value: "colectie-8837/minecraft"
    },
    {
        img: "ninjago",
        value: "colectie-8837/ninjago"
    }, 
];
var LegoByTheme = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-8 sm:max-w-[60%] md:max-w-[35%] -ml-[8px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "".concat(LegoByTheme_settings.websiteStatics, "/images/universul-lego/theme_title.png"),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSection/* default */.Z, {
                padding: "p-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "grid grid-rows-2 grid-flow-col overflow-x-scroll gap-4 px-4 md:grid-flow-row md:grid-rows-none md:grid-cols-4 lg:grid-cols-5",
                    children: themes.map(function(param, index) {
                        var img = param.img, value = param.value;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            className: "w-40 sm:w-48 md:w-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/lego-jucarii/cpl/filtru/".concat(value, "/"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    title: "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(LegoByTheme_settings.websiteStatics, "/images/universul-lego/tema/").concat(img, ".png"),
                                        alt: ""
                                    })
                                })
                            })
                        }, index);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_LegoByTheme = (LegoByTheme);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
;// CONCATENATED MODULE: ./components/FormGeneric/Select.js


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Select = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("select", _objectSpread({
        className: "rounded-tr-lg rounded-bl-lg border border-gray-1100 w-full bg-white px-15px",
        style: {
            paddingTop: "11px",
            paddingBottom: "12px",
            lineHeight: "20.8px",
            maxWidth: "390px",
            fontSize: "16px"
        }
    }, props, {
        children: children
    }));
};
/* harmony default export */ var FormGeneric_Select = (Select);

;// CONCATENATED MODULE: ./components/FormGeneric/FormError.js


var FormError = function(param) {
    var children = param.children;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "text-red-brand text-sm my-2",
        children: children
    });
};
/* harmony default export */ var FormGeneric_FormError = (FormError);

;// CONCATENATED MODULE: ./components/Icons/BrickListItem.js


var BrickListItem = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 30 : _height, _number = param.number, number = _number === void 0 ? "" : _number;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 28 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24 0H4V6H0V30H28V6H24V0Z",
                fill: "#F5CB38"
            }),
            number && /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                fill: "black",
                xmlSpace: "preserve",
                style: {
                    "white-space": "pre"
                },
                fontFamily: "IBM Plex Sans",
                fontSize: "16",
                letterSpacing: "-0.333333px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                    x: "9",
                    y: "22.5",
                    children: number
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_BrickListItem = (BrickListItem);

;// CONCATENATED MODULE: ./components/LegoWizard.js








var LegoWizard_ref = (0,config["default"])(), LegoWizard_settings = LegoWizard_ref.publicRuntimeConfig.settings;
var options = {
    age: {
        key: "varsta-8282",
        values: [
            {
                name: "1-2 ani",
                key: "1-2-ani"
            },
            {
                name: "3-4 ani",
                key: "3-4-ani"
            },
            {
                name: "5-7 ani",
                key: "5-6-ani_6-7-ani_7-8-ani"
            },
            {
                name: "8-12 ani",
                key: "8-9-ani_9-10-ani_10-11-ani_11-12-ani"
            },
            {
                name: "12-14-ani",
                key: "peste-12-ani"
            },
            {
                name: ">12 ani",
                key: "peste-12-ani"
            }, 
        ]
    },
    price: {
        key: "price",
        values: [
            {
                name: "Sub 50",
                key: "0-50"
            },
            {
                name: "50-100",
                key: "50-100"
            },
            {
                name: "100-200",
                key: "100-200"
            },
            {
                name: "200-500",
                key: "200-500"
            },
            {
                name: "500-1000",
                key: "500-1000"
            },
            {
                name: "1000-1500",
                key: "1000-1500"
            },
            {
                name: "1500-2000",
                key: "1500-2000"
            },
            {
                name: "2000-3000",
                key: "2000-3000"
            },
            {
                name: "Peste 3000",
                key: "3000-4000"
            }, 
        ]
    },
    interest: {
        key: "interese-9351",
        values: [
            {
                img: "spatiu",
                key: "spatiu",
                color: "#2D3A8C"
            },
            {
                img: "sport",
                key: "sport",
                color: "#FF9D00"
            },
            {
                img: "supereroi",
                key: "super-eroi",
                color: "#EC3333"
            },
            {
                img: "animale",
                key: "animale",
                color: "#808F89"
            },
            {
                img: "decor",
                key: "decor",
                color: "#C9712D"
            },
            {
                img: "dinozauri",
                key: "dinozauri",
                color: "#708D00"
            },
            {
                img: "casute",
                key: "casute",
                color: "#00569F"
            },
            {
                img: "cinema",
                key: "cinema",
                color: "#C60102"
            },
            {
                img: "ninja",
                key: "ninja",
                color: "#B50806"
            },
            {
                img: "printese",
                key: "printese",
                color: "#F6CC00"
            },
            {
                img: "gaming",
                key: "jocuri-video",
                color: "#C96DFD"
            },
            {
                img: "masinute",
                key: "masini",
                color: "#625D59"
            }, 
        ]
    }
};
var getProductSearchURL = function(param) {
    var _age = param.age, age = _age === void 0 ? "" : _age, _price = param.price, price = _price === void 0 ? "" : _price, _interests = param.interests, interests = _interests === void 0 ? [] : _interests;
    var ageQuery = "";
    var priceQuery = "";
    var interestsQuery = "";
    if (age) ageQuery = "".concat(options.age.key, "/").concat(age, "/");
    if (price) priceQuery = "".concat(options.price.key, "/").concat(price, "/");
    if (interests.length) interestsQuery = "".concat(options.interest.key, "/").concat(interests.join("_"), "/");
    return "/lego-jucarii/cpl/filtru/".concat(ageQuery).concat(priceQuery).concat(interestsQuery);
};
var LegoWizard = function() {
    var ref4 = (0,react.useState)(""), selectedAge = ref4[0], setAge = ref4[1];
    var ref1 = (0,react.useState)(""), selectedPrice = ref1[0], setPrice = ref1[1];
    var ref2 = (0,react.useState)([]), selectedInterests = ref2[0], setInterests = ref2[1];
    var ref3 = (0,react.useState)(""), error = ref3[0], setError = ref3[1];
    var resetError = function() {
        return setError("");
    };
    var searchProducts = function() {
        if (!selectedAge && !selectedPrice && !selectedInterests.length) {
            setError("Selecteaza mai intai varsta, pretul sau un interes.");
            return;
        }
        var url = getProductSearchURL({
            age: selectedAge,
            price: selectedPrice,
            interests: selectedInterests
        });
        router["default"].push(url);
    };
    var handleSetInterest = function(key) {
        if (selectedInterests.includes(key)) {
            setInterests(selectedInterests.filter(function(interestKey) {
                return interestKey !== key;
            }));
        } else {
            setInterests(selectedInterests.concat(key));
        }
        if (error) resetError();
    };
    var handleSetAge = function(key) {
        setAge(key);
        if (error) resetError();
    };
    var handleSetPrice = function(key) {
        setPrice(key);
        if (error) resetError();
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-8 sm:max-w-[60%] md:max-w-[35%]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "".concat(LegoWizard_settings.websiteStatics, "/images/universul-lego/wizzard_title.png"),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col lg:flex-row mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col sm:flex-row mb-6 lg:mb-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-grow flex-col sm:flex-row mb-4 sm:mb-0 sm:items-center mr-0 sm:mr-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center mb-3 sm:mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mr-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BrickListItem, {
                                                    number: 1
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "age",
                                                className: "mr-4",
                                                children: "Varsta"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGeneric_Select, {
                                        id: "age",
                                        onChange: function(event) {
                                            return handleSetAge(event.target.value);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "",
                                                children: "Alege varsta"
                                            }),
                                            options.age.values.map(function(param, index) {
                                                var name = param.name, key = param.key;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                    value: key,
                                                    children: name
                                                }, index);
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-grow flex-col sm:flex-row sm:items-center mr-0 sm:mr-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center mb-3 sm:mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mr-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BrickListItem, {
                                                    number: 2
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "price",
                                                className: "mr-4",
                                                children: "Pret"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGeneric_Select, {
                                        id: "price",
                                        onChange: function(event) {
                                            return handleSetPrice(event.target.value);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "",
                                                children: "Alege pretul"
                                            }),
                                            options.price.values.map(function(param, index) {
                                                var name = param.name, key = param.key;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("option", {
                                                    value: key,
                                                    children: [
                                                        name,
                                                        " RON"
                                                    ]
                                                }, index);
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-3 sm:mb-0 mr-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BrickListItem, {
                                    number: 3
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "mb-0",
                                        children: "Interese"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "md:text-sm text-gray-dark",
                                        children: "Selecteaza dintre categoriile de mai jos"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "grid grid-rows-2 grid-flow-col overflow-x-scroll gap-4 md:grid-flow-row md:grid-rows-none md:grid-cols-4 lg:grid-cols-6 px-4 py-5",
                children: options.interest.values.map(function(param, index) {
                    var img = param.img, key = param.key, color = param.color;
                    var isSelected = selectedInterests.includes(key);
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "relative w-40 sm:w-48 md:w-auto cursor-pointer ".concat(isSelected ? "shadow-lg" : ""),
                        onClick: function() {
                            return handleSetInterest(key);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "".concat(LegoWizard_settings.websiteStatics, "/images/universul-lego/interese/").concat(img, ".png"),
                                alt: ""
                            }),
                            isSelected && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pointer-events-none absolute inset-0 border-2",
                                        style: {
                                            borderColor: color
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pointer-events-none absolute top-2 right-2 w-5 h-5 rounded-full flex items-center justify-center",
                                        style: {
                                            backgroundColor: color
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            className: "w-3 h-3",
                                            fill: "none",
                                            stroke: "white",
                                            strokeWidth: "3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                                points: "5 12 10 17 19 8"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }, index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sm:text-center mt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: searchProducts,
                        title: "Vezi produsele",
                        disabled: Boolean(error)
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGeneric_FormError, {
                        children: error
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_LegoWizard = (LegoWizard);

;// CONCATENATED MODULE: ./components/LegoPromoCategories.js




var LegoPromoCategories_ref = (0,config["default"])(), LegoPromoCategories_settings = LegoPromoCategories_ref.publicRuntimeConfig.settings;
var categories = [
    {
        img: "noutati",
        value: "noutati-5218/noutati"
    },
    {
        img: "oferte",
        value: "promotii-3803/promotii/in-stoc-5182/in-stoc/filtru-promotii/has-promotion"
    },
    {
        img: "articole-rare",
        value: "pentru-9396/adulti"
    }, 
];
var LegoPromoCategories = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "flex",
        children: categories.map(function(param, index) {
            var img = param.img, value = param.value;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/lego-jucarii/cpl/filtru/".concat(value),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    title: "",
                    className: "lg:mx-12 text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat(LegoPromoCategories_settings.websiteStatics, "/images/universul-lego/").concat(img, ".png"),
                        alt: ""
                    })
                })
            }, index);
        })
    });
};
/* harmony default export */ var components_LegoPromoCategories = (LegoPromoCategories);

// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
// EXTERNAL MODULE: ./lib/api/helpers.js
var helpers = __webpack_require__(45963);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./lib/transformV2Banners.js
var transformV2Banners = __webpack_require__(6100);
;// CONCATENATED MODULE: ./pages/universul-lego.js
















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var universul_lego_ref = (0,config["default"])(), universul_lego_settings = universul_lego_ref.publicRuntimeConfig.settings;
var LegoUniverse = function(param) {
    var notFound = param.notFound, heroBanner = param.heroBanner;
    if (notFound) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
            layout: "404"
        }));
    }
    var hasHeroBanner = heroBanner && heroBanner.position === "CONTENT_TOP";
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Universul LEGO\xae"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                breadcrumbs: [
                    {
                        id: 1,
                        level: 99,
                        name: "Universul LEGO\xae"
                    }, 
                ]
            }),
            hasHeroBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-12 mx-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveHeroBanner/* default */.Z, {
                    banner: heroBanner
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-100 mb-16 px-8 pt-10 pb-12 -mx-4 sm:mx-0 sm:rounded-tr-lg sm:rounded-bl-lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LegoWizard, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LegoPromoCategories, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LegoByAge, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LegoByPassion, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LegoByTheme, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "".concat(universul_lego_settings.baseUrl, "/lego-adulti/pag/"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    title: "",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "hidden md:block",
                            src: "".concat(universul_lego_settings.websiteStatics, "/images/universul-lego/descopera-un-nou-mod-de-a-te-destinde.png"),
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "md:hidden",
                            src: "".concat(universul_lego_settings.websiteStatics, "/images/universul-lego/descopera-un-nou-mod-de-a-te-destinde-mobile.png"),
                            alt: ""
                        })
                    ]
                })
            })
        ]
    }));
};
LegoUniverse.getInitialProps = (function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var res, heroBanner;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    res = param.res;
                    if (!(universul_lego_settings.websiteName === "mediagalaxy" || universul_lego_settings.websiteName === "bricostore")) {
                        _ctx.next = 4;
                        break;
                    }
                    if (res) res.statusCode = 404;
                    return _ctx.abrupt("return", {
                        notFound: true
                    });
                case 4:
                    _ctx.next = 6;
                    return (0,helpers/* makeApiCall */.Vo)({
                        apiCall: api/* getBannersV2Api */.a5o,
                        apiArgs: [
                            {
                                id: 44
                            }
                        ],
                        formatResponse: function(response) {
                            return response.data;
                        },
                        returnResponse: true
                    });
                case 6:
                    heroBanner = _ctx.sent;
                    if (!heroBanner) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        heroBanner: (0,transformV2Banners/* default */.Z)(heroBanner)
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
})();
LegoUniverse.pageLayout = "default";
/* harmony default export */ var universul_lego = (LegoUniverse);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(68359); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);